module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 0iPh
// module chunks = 15 16 17 18 19 22 25 26 28 29 30 33 36 37 38 42 44 45 47 49 54 57 61 62 63 64 65